export const SKILLS_POPUP = {
    ADD_SKILL: 'Add Skill',
    RATE_EXPERTISE: 'Rate your expertise in',
    ADD_SUCCESS: 'skill has been successfully added.',
    ADD_ANOTHER: 'Would you like to add another skill?',
    ADD_MORE_SKILL: 'Yes, Add More',
    ADD_SKILL_NO: 'No'
}